export default __webpack_public_path__ + "static/media/download_white.53f756d5.svg";